import { type Enum } from "@/types/utils";

export const logoLayouts = {
  VERTICAL: "vertical",
  HORIZONTAL: "horizontal",
} as const;

export type LogoLayouts = Enum<typeof logoLayouts>;

export interface IAxis {
  x: number;
  y: number;
}

export interface ILogoConfig {
  width: number;
  height: number;
  l: IAxis;
  t: IAxis;
  k: IAxis;
}
